import {apiSlice} from './baseApi';
import {ClusterLevelMap, HazardParameter, HazardType, HazardTypeClass} from '../../types/internal/Hazard';
import {TaskStatusAsyncModel} from '../../types/api/assets';

export type BulkPatchHazardParameterItem = {
  uuid: string;
  magnitude: number;
  to_be_used_in_impact: boolean;
};

const hazardTypesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getHazardTypes: build.query<HazardType[], void>({
      query: () => ({
        url: `/hazard-types/`,
        params: {
          paginate: false,
        },
      }),
      providesTags: ['Locale'],
    }),
    getHazardTypeClasses: build.query<HazardTypeClass[], void>({
      query: () => ({
        url: `/hazard-type-classes/`,
        params: {
          paginate: false,
        },
      }),
      providesTags: ['Locale', 'HazardTypes'],
    }),
    getHazardParameters: build.query<HazardParameter[], void>({
      query: () => ({
        url: `/hazard-parameters/`,
        params: {
          paginate: false,
        },
      }),
      providesTags: ['Locale', 'HazardParameters'],
    }),
    patchHazardParametersBulk: build.mutation<{uuid: string}, BulkPatchHazardParameterItem[]>({
      query: (body) => ({
        url: `/hazard-parameters/bulk_update_parameters/`,
        method: 'PATCH',
        body,
      }),
    }),
    hazardParametersBulkUpdateTaskStatus: build.query<TaskStatusAsyncModel, string>({
      query: (uuid) => {
        return {
          url: '/hazard-parameters/async_task_status/',
          params: {uuid}
        }
      }
    }),
    getClusterLevelMap: build.query<ClusterLevelMap[], void>({
      query: () => ({
        url: `/cluster_level_map/`,
        params: {
          paginate: false,
        },
      }),
      providesTags: ['Locale'],
    }),
  }),
});

export const {
  useGetHazardTypesQuery,
  useGetHazardTypeClassesQuery,
  useGetHazardParametersQuery,
  useGetClusterLevelMapQuery,
  usePatchHazardParametersBulkMutation,
  useLazyHazardParametersBulkUpdateTaskStatusQuery
} = hazardTypesApi;